<template>
  <div>
    <InputElement
      v-model="value"
      type="date"
      v-bind="{ uid, hasError, placeholder, disabled, focus, size }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import InputElement from './_shared/InputElement.vue';
import props from './_shared/props';

export default defineComponent({
  components: {
    InputElement,
  },
  inheritAttrs: false,
  props: {
    modelValue: String,
    type: String,
    ...props(),
  },
  emits: ['update:modelValue'],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
});
</script>
